export const interestRate = 8;
export const minLoanAmount = 5000;
export const maxLoanAmount = 25000;
export const loanTermValues = {
  6: "6 mėn.",
  12: "1 m.",
  24: "2 m.",
  36: "3 m.",
  48: "4 m.",
  60: "5 m.",
  72: "6 m.",
  84: "7 m.",
  96: "8 m.",
  108: "9 m.",
  120: "10 m.",
};

export const steps = [
  500, 750, 1000, 1500, 2000, 2500, 3000, 4000, 5000, 6000, 7000, 8000, 9000, 10000, 11000, 12000, 13000, 14000, 15000,
  16000, 17000, 18000, 19000, 20000, 21000, 22000, 23000, 24000, 25000, 26000, 27000, 28000, 29000, 30000,
];
